<template>
	<div class="container-fluid">
		<div class="row">
			<h5 class="text-danger">Hello from Admin </h5>
		</div>
	</div>
</template>
<script setup></script>
<style scoped></style>